import { useSetting } from "@faire/deprecated-retailer-visitor-shared/settings/__internal__/useSetting";
import { useAssignSetting } from "@faire/deprecated-retailer-visitor-shared/settings/__internal__/useSetting";
import { ENABLE_NEW_SEARCH_SUGGESTIONS_EMPTY_STATE_250530 } from "@faire/web-api--source/indigofair/settings/ENABLE_NEW_SEARCH_SUGGESTIONS_EMPTY_STATE_250530";

export const useSettingEnableNewSearchSuggestionsEmptyState = (): boolean =>
  useSetting(ENABLE_NEW_SEARCH_SUGGESTIONS_EMPTY_STATE_250530, false);

export const useAssignSettingEnableNewSearchSuggestionsEmptyState = () =>
  useAssignSetting(ENABLE_NEW_SEARCH_SUGGESTIONS_EMPTY_STATE_250530);
